class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    /* Scrim only — never treat the field/results as an outside click. */
    if (event.target.closest('.search-modal__content')) return;
    if (event.target.classList.contains('modal-overlay') || !this.contains(event.target)) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);

    this.scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    const header = document.querySelector('.section-header');
    const rect = header ? header.getBoundingClientRect() : null;
    const top = rect ? Math.max(0, Math.round(rect.top)) : 0;
    let space = 0;
    if (header && rect) {
      const marginBottom = parseFloat(window.getComputedStyle(header).marginBottom) || 0;
      space = Math.round(rect.height + marginBottom);
    }

    /*
      Pin at the header's current on-screen top, and reserve its in-flow height
      so switching sticky→fixed does not collapse the page (the jump).
      Class + vars must land before body lock / details open.
    */
    document.documentElement.style.setProperty('--search-header-top', `${top}px`);
    document.documentElement.style.setProperty('--search-header-space', `${space}px`);
    document.documentElement.style.setProperty('--search-scroll-lock-y', `-${this.scrollY}px`);
    document.documentElement.classList.add('search-open');
    event.target.closest('details').setAttribute('open', true);
    document.body.classList.add('overflow-hidden', 'search-scroll-locked');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
    const searchInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
    /* preventScroll: plain focus() makes mobile Safari scroll the field into view → jump. */
    trapFocus(focusContainer, focusContainer);
    if (searchInput) searchInput.focus({ preventScroll: true });
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden', 'search-scroll-locked');
    document.documentElement.classList.remove('search-open');
    document.documentElement.style.removeProperty('--search-scroll-lock-y');
    document.documentElement.style.removeProperty('--search-header-top');
    document.documentElement.style.removeProperty('--search-header-space');

    if (typeof this.scrollY === 'number') {
      window.scrollTo(0, this.scrollY);
      this.scrollY = null;
    }
  }
}

customElements.define('details-modal', DetailsModal);
